/**
 * Formats a numeric amount as a Euro price string without decimal digits.
 * @param amount - The amount in cents to format
 * @returns A formatted string with the Euro symbol and grouped thousands separators
 * @example
 * formatEuroPriceWithoutDigit(1500) // "€1,500"
 * formatEuroPriceWithoutDigit(50) // "€0"
 */
export function formatEuroPriceWithoutDigit(amount: number) {
  return `€${(amount / 100).toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    useGrouping: true,
  })}`;
}
